import React, { useState } from "react";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { B } from "./TextStyles";
import UpdateDisplayNameModal from "./UpdateDisplayNameModal";

export default function UpdateDisplayName({ userData }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Stack direction="row" spacing={3} sx={{ flexWrap: "wrap" }}>
        <Typography variant="h6">Current display name:</Typography>
        <Typography variant="h6" noWrap>
          <B>{userData.displayName}</B>
        </Typography>
        <Button variant="contained" onClick={handleOpen}>
          <Typography variant="button">Update</Typography>
        </Button>
      </Stack>
      <UpdateDisplayNameModal onClose={handleClose} open={open} />
    </>
  );
}
